<template >
    <div class="container-fluid" v-if="lesson">
  

      <div class="card shadow mb-4">
          
        <div class="card-header py-3">
          <div class="row">
            <div class='col'>
              <h3>Хичээл үзэж байгаа оюутнууд</h3>
            </div>
            <!-- <div class="col-auto">
              <button class="btn btn-success btn-sm" @click="$router.push({ name: 'LessonAttendance', params: { lessonId: lessonId} })" >Ирцийн мэдээлэл</button>
            </div> -->
          </div>
        </div>
        <div class="card-body">
          
          <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0" v-if="students!=null && students.length>0">
            <thead>
              <tr>
                <th>№</th>
                <th>Овог/Нэр</th>
                <th>Оюутны дугаар</th>
                <th>Регистр</th>
                <th>Төлөв</th>
                <th>Төлбөр</th>
                <th>Үйлдэл</th>

              </tr>
            </thead>

            <tbody>
              <tr v-for="(std, index) in students" v-bind:key="std.id">
                <td>{{index+1}}</td>
                <td><span v-if="std.student!=null">{{std.student.lastname}}/{{std.student.name}}</span></td>

                <td><span v-if="std.student!=null">{{std.student.code}}</span></td>
                <td><span v-if="std.student!=null">{{std.student.register}}</span></td>
                <td>
                  <span v-if="std.enabled==true" class="badge badge-pill badge-success">идэвхтэй</span>
                  <span v-else class="badge badge-pill badge-danger">блоклосон</span>
                </td>
                <td>    
                    <div v-if="std.paymentData">
                        <div class="badge badge-success" v-if="std.paymentData.paid!=null && std.paymentData.paid!=undefined && std.paymentData.paid==true">төлсөн</div>
                        <div class="badge badge-danger" v-else>төлсөн</div>
                        <!-- төлөөгүй -->
                    </div>
                    <div v-else>
                        <div class="badge badge-danger">төлсөн</div> 
                        <!-- төлөөгүй -->
                    </div>
                </td>
                <td>

                  <button class='btn btn-sm btn-danger' @click="removeStudent(std)">хасах</button>
                  <button v-if="std.enabled==true" class='btn btn-sm btn-primary  mx-1' @click="setEnabledForStudent(std, false)">эрх хаах</button>
                  <button v-else class='btn btn-sm btn-primary mx-1' @click="setEnabledForStudent(std, true)">эрх нээх</button>
                </td>
              </tr>
              
            </tbody>
          </table>
          <div v-else class="alert alert-info text-center">
              Одоогоор энэ хичээлийг үзэж байгаа оюутан байхгүй байна.
          </div>
          <hr class="py-3 mt-3"/>
            <form class="user">
              <div>
                "<span  style="color:red">Оюутны код</span> &nbsp;&nbsp;<span style="color:blue">Регистр</span>" форматаар оруулна уу!!!.  Жишээ нь:
                <br/>
                D123456 УХ0000000<br/>
                D123457 БА99999999
                <br/>
                <div class="text-danger">Та дээрх форматнаас зөрүүлж оруулсан тохиолдолд оюутан xичээлийг үзэx боломжгүй болоxыг анxаарна уу!!!</div>
              </div>
              <div class="form-group">
                <textarea rows="10" v-model.trim="studentsText" class="form-control" placeholder="Оюутнуудын мэдээлэл"/>
              </div>
           
              <button type="button" class="btn btn-primary mr-2" @click="addStudents">
                Оюутан нэмэх
              </button>
              <button type="button" class="btn btn-danger" @click="bulkStudents" title="Тусгай форматаар оюутныг бөөнөөр нэмэx үйлдэл">
                Оюутан бөөнөөр нэмэх
              </button>
              <hr>
              
            </form>
            <div class="py-3">

              <h4>Оюутан хайх <span class="text-primary" style="font-size:12pt">/Шүүлтүүр xэрэглэн оюутан xайж xичээлдээ нэмэx боломжтой/</span></h4>
              <hr/>
              <div>
                <div class="row">
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label >Сургууль</label>
                      <select class="form-control" v-model="school">
                        <option v-for="(school, index) in schools" v-bind:key="school.id" v-bind:value="school">{{index+1}}.  {{school.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4" v-if="school">
                    <div class="form-group">
                      <label >Xөтөлбөрийн баг /Тэнхим/</label>
                      <select class="form-control" v-model="department" >
                        <option v-for="(dep, index) in departments" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4" v-if="school">
                    <div class="form-group">
                      <label >Хөтөлбөр</label>
                      <select class="form-control" v-model="program">
                        <option v-for="(school, index) in programs" v-bind:key="school.id" v-bind:value="school">{{index+1}}.  {{school.name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="school">
                  
                  <div class="col-sm-12 col-md-4" >
                    <div class="form-group">
                      <label >Мэргэжлийн төлөвлөгөө</label>
                      <select class="form-control" v-model="programYear" >
                        <option v-for="(dep, index) in programyears" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4" >
                    <div class="form-group">
                      <label >Элсэн орсон семестер</label>
                      <select class="form-control" v-model="selectedSemester" >
                        <option v-for="(dep, index) in semesters" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.title}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4" >
                    <div class="form-group">
                      <label>&nbsp;</label>
                      <button class="btn btn-block btn-success" @click="searchStudents">Хайх</button>
                    </div>
                  </div>
                  
                </div>
                <hr/>
              </div>

              <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0" v-if="searchresults!=null && searchresults.length>0">
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Овог/Нэр</th>
                    <th>Оюутны дугаар</th>
                    <th>Регистр</th>
                    <th>Үйлдэл</th>

                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(std, index) in searchresults" v-bind:key="std.id">
                    <td>{{index+1}}</td>
                    <td><span v-if="std!=null">{{std.lastname}}/{{std.name}}</span></td>

                    <td><span v-if="std!=null">{{std.code}}</span></td>
                    <td><span v-if="std!=null">{{std.register}}</span></td>

                    <td>

                      <!-- <button class='btn btn-sm btn-danger' @click="removeStudent(std)">хасах</button>
                      <button v-if="std.enabled==true" class='btn btn-sm btn-primary  mx-1' @click="setEnabledForStudent(std, false)">эрх хаах</button> -->
                      <div v-if="checkStudentIn(std)!=true">
                        <button class='btn btn-sm btn-primary mx-1' @click="addSearchStudent(std)">нэмэх</button>
                      </div>
                      <div v-else>
                        <label class="badge badge-success">нэмэгдсэн</label>
                      </div>
                    </td>
                  </tr>
                  
                </tbody>
              </table>
              <div v-else class="text-center alert alert-info">
                <p>Одоогоор хайлтын мэдээлэл байхгүй байна.</p>
              </div>
            </div>


            <hr/>
            
        </div>

      </div>

      <div class="modal fade bd-example-modal-lg" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
        <div class="modal-dialog  modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">Оюутан нэмэх</h5>
        
            </div>
            <div class="modal-body">
                <div class="table-responsive" v-if="tmpStudents!=null && tmpStudents.length>0">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th>Оюутны код</th>
                        <th>Регистр</th>

                        <th>Үйлдэл</th>
                    </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(student, index) in tmpStudents" >
                            <td>{{index+1}}</td>
                            <td>
                              <input type="text" v-model="student.code"/>
                            </td>
                   
                            <td>
                              <input type="text" v-model="student.register"/>
                            </td>
             
                            <td>
                                <button class="btn btn-success btn-sm" @click="checkStudentAdd(student, index)">Нэмэх</button>
                            </td>
                        </tr>
                    
                    </tbody>
                </table>
           
                </div>
            </div>
        
          </div>
        </div>
      </div>
    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'


export default {
    name: "LessonDetail",

    data() {
        return {
            lesson: null,

            types:[],
            studentsText:'',
            selectedTopic:null,
            tmpStudents:[],
            students:[],
            searchresults:[],

            lessonBucket:'lessonFiles/',
            topicBucket:'lessonTopicFiles/',
            schools:[],
            departments:[],
            programs:[],
            programyears:[],
            school:null,
            department:null,
            program:null,
            programYear:null,
            semesters:[],
            selectedSemester:null,
            firstSet:false
            
        };
    },
    watch: {
      school: function (val) {
        if(val && val.ref){
          this.departments=[];
          this.programs=[];
          this.programyears=[];
          this.department=null;
          this.program=null;
          this.programYear=null;
          this._getDepartments(val);
        }
      },
      department: function (val) {
        if(val && val.ref){
          this.programs=[];
          this.programyears=[];
          this.program=null;
          this.programYear=null;
          this._getPros(val);
        }
      },
      program: function (val) {
        if(val && val.ref){
          this.programyears=[];
          this.programYear=null;
          this._getProgramYears(val);
        }
      },
    },
    methods: {
        
      _getQA(){

          fb.db.collection("lessons").doc(this.lessonId).onSnapshot(doc=> {
              let lesson=doc.data();
              lesson.id=doc.id
              lesson.schoolName=null;
              lesson.departmentName=null;
              lesson.programName=null;
              this.lesson=lesson;

              fb.db.collection("lessons/"+this.lessonId+'/studentList').onSnapshot(querySnapshot=> {
                this.students=[]
                querySnapshot.forEach(stddata=> {
                  let object=stddata.data()
                  object.id = stddata.id;
                  object.student=null;
                  object.ref=stddata.ref;
                  object.paymentData=null;
                  if(stddata.data().studentRef!=null){
                    stddata.data().studentRef.get().then(studentDoc=>{
                      object.student=studentDoc.data();
                      if(this.lesson.semester){
                        studentDoc.ref.collection("paymentHistory").doc(this.lesson.semester.id).onSnapshot(pdoc=>{
                          if(pdoc.exists){
                              object.paymentData=pdoc.data();
                          }
                        });
                      }
                    });
                  }
                  this.students.push(object);
                });
              
              });

          });

      },
     
      goStat(type, topic){
        this.$router.push({ name: 'TopicStat', params: { lessonId: this.lessonId, type: type.id, topicId: topic.id} })
      },
      bulkStudents(){
        var currentQuestion;
        var questions = [];

        if(this.studentsText!=null && this.studentsText!=''){
          var arrayOfLines = this.studentsText.match(/[^\r\n]+/g);
          this.tmpStudents=[];
          if(arrayOfLines!=null && arrayOfLines.length>0){
            arrayOfLines.forEach(value=>{
              // console.log(value);
              var lineArray=value.split(/\s+/);
              if(
                value.startsWith('A.') ||
                value.startsWith('B.') ||
                value.startsWith('C.') ||
                value.startsWith('D.') ||
                value.startsWith('E.') ||
                value.startsWith('F.') 
              ){
                if(currentQuestion!=null) {
                  currentQuestion.answers.push({name:value})
                }
              } else if(value.endsWith('оноо\\')){
                console.log(value.trim().replace('оноо\\','').replace('\\',''));
              }
              else if(value.endsWith('оноо]')){
                console.log(value.trim().replace('оноо]','').replace('[',''));
              }
              for(var i=0; i< 100; i++){
                if(value.startsWith(i+'.')) {
                  currentQuestion = {name:value, answers:[]};
                  questions.push(currentQuestion);
                  break;
                } 
              }
            });
            this.studentsText='';
          }
        }

      },
      addStudents(){
        if(this.studentsText!=null && this.studentsText!=''){

          var arrayOfLines = this.studentsText.match(/[^\r\n]+/g);
          this.tmpStudents=[];
          if(arrayOfLines!=null && arrayOfLines.length>0){
            arrayOfLines.forEach(value=>{
              // console.log(value);
              var lineArray=value.split(/\s+/);
              if(lineArray!=null && lineArray.length==2 && lineArray[0]!=null && lineArray[0]!='' && lineArray[1]!=null && lineArray[1]!=''){
                // var lessonRef= fb.db.collection("lessons").doc(this.lessonId);
                // var studentRef=fb.db.collection("students").doc(lineArray[0].toLowerCase()).get().then(studentData=>{
                  var studentDetail={};

                //   if(studentData!=null && studentData.exists){
                //     studentDetail.id=studentData.id;
                //     studentDetail.code=studentData.data().code;
                //     studentDetail.register=studentData.data().register;
                //     studentDetail.name=studentData.data().name;
                //     studentDetail.lastname=studentData.data().lastname;
                //     studentDetail.allowed=true;
                //     this.tmpStudents.push(studentDetail);
                //     // studentDetail=studentData.data();
                //     // this.addStudentToLesson(lessonRef, studentData, studentDetail);
                //   }
                //   else{
                    // fb.db.collection("students").where("register", "==", lineArray[1].toLowerCase()).get().then(value=>{
                    //   if(value.empty)
                    //   {
                    var allowed=false;
                    // if(lineArray[0].toLowerCase().startsWith("d")==true && lineArray[1].length>=6)
                    if(lineArray[1].length>=6)
                      allowed=true;
                    // if(lineArray[0].length>0 && lineArray[1].length>=6)
                    //   allowed=true;
            
                    studentDetail={
                      'code':lineArray[0].toLowerCase(),
                      'register': lineArray[1].toLowerCase(),
                      // 'lessons': fb.firestore.FieldValue.arrayUnion(lessonRef),
                      'id':null,
                      'allowed':allowed
                    };
                    this.tmpStudents.push(studentDetail);
                    //     studentData.ref.set(
                    //       studentDetail
                    //     );
                    //     this.addStudentToLesson(lessonRef, studentData, studentDetail);
                    //   }
                    // });
                
                  // }
                  
                // });

              }
            });
            this.studentsText='';
            $('.bd-example-modal-lg').modal('show');
          }
        }
      },
      async checkStudentAdd(std, index){
        if(std!=null && std.code!=null && std.register!=null){
          // if(std.code.length<1){
          // if(std.code.startsWith("d")==false){
          //   alert("Оюутны код буруу форматтай байна.Засна уу? d0123456 форматтай байх.");
          //   return;
          // }
          if(std.register.length<6){
            alert("Оюутны регистрийн дугаар буруу байна .");
            return;
          }
          var lessonRef= fb.db.collection("lessons").doc(this.lessonId);
          var stdExists=await fb.db.collection("students").where("code", '==', std.code).where("register", "==", std.register).limit(1).get();
          if(!stdExists.empty){
            std.allowed=true;
            this.addStudentToLesson(lessonRef, stdExists.docs[0], std);
            this.tmpStudents.splice(index, 1);
            this.checkModalShow();
          }
          else{

            var stdCheckByCode=await fb.db.collection("students").doc(std.code).get();
            if(stdCheckByCode.exists){
              var r = confirm(std.code+" кодтой оюутаны регистрийн дугаар зөрж байна.Бүртгэгдсэн регистрийн дугаар "+ stdCheckByCode.data().register+", нэр "+stdCheckByCode.data().name+" байна.ТА энэ оюутныг хичээл дээр нэмэх үү?");
              if (r == true) {
                this.addStudentToLesson(lessonRef,  stdCheckByCode, std);
                this.tmpStudents.splice(index, 1);
                this.checkModalShow();
              } 
              return;
            }

            var stdCheckByRegister=await fb.db.collection("students").where("register", "==", std.register).limit(1).get();
            if(!stdCheckByRegister.empty){
              var r = confirm(std.register+" регистертэй оюутаны код зөрж байна.Бүртгэгдсэн оюутны код "+ stdCheckByRegister.docs[0].data().code+", нэр "+stdCheckByRegister.docs[0].data().name+" байна.ТА энэ оюутныг хичээл дээр нэмэх үү?");
              if (r == true) {
                this.addStudentToLesson(lessonRef,  stdCheckByRegister.docs[0], std);
                 this.tmpStudents.splice(index, 1);
                 this.checkModalShow();
              } 
              return;
            }


           
            std.allowed=true;
            // var newStdRef=fb.db.collection("students").doc(std.code);
            // newStdRef.set({"code": std.code, 'register':std.register, "createdAt": new Date(), "created": fb.db.collection("users").doc(this.$store.getters.currentUser.uid)});
            // var stdData=await newStdRef.get();
            // this.addStudentToLesson(lessonRef, stdData, std);
            // this.tmpStudents.splice(index, 1);
            // this.checkModalShow();
            
          }
        }
        else{
          alert("Оюутны мэдээлэл дутуу байна.");
        }
      },
      checkModalShow(){
        if(this.tmpStudents.length==0)
          $('.bd-example-modal-lg').modal('hide');
      },
      addStudentToLesson(lessonRef, studentData, studentDetail){
        studentData.ref.collection("lessonList").doc(lessonRef.id).get().then(stLesson=>{
          if(stLesson!=null && stLesson.exists){
            alert("Аль хэдийн нэмэгдсэн байна.");
          }
          else{
            studentData.ref.collection("lessonList").doc(lessonRef.id).set({
              lessonRef: lessonRef,
              addedDate: new Date(),
              addedUser: fb.usersCollection.doc(this.$store.getters.currentUser.uid),
              enabled:true,
              semester: this.lesson.semester
            })
          }
        });
        
        lessonRef.collection("studentList").doc(studentData.id).get().then(lessonSt=>{
          if(lessonSt!=null && lessonSt.exists){
            alert("Аль хэдийн нэмэгдсэн байна.");
          }
          else{
            lessonRef.update({
              'numberOfStudents': fb.firestore.FieldValue.increment(1)
            });
            lessonRef.collection("studentList").doc(studentData.id).set({
              addedDate:new Date(),
              addedUser: fb.usersCollection.doc(this.$store.getters.currentUser.uid),
              studentRef: studentData.ref,
              enabled:true,
              semester: this.lesson.semester
            })
          }
        });
      },
 
   
      setEnabledForStudent(stddata, value){
        this.setProperty("enabled", stddata.ref, value);
        this.setProperty("enabled", fb.db.doc("students/"+stddata.id+"/lessonList/"+this.lessonId), value);
        
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
      removeStudent(stddata){
        fb.db.doc("students/"+stddata.id+"/lessonList/"+this.lessonId).delete();
        stddata.ref.delete();
        fb.db.collection("lessons").doc(this.lessonId).update({
          'numberOfStudents': fb.firestore.FieldValue.increment(-1)
        });

      },
      _getSchools(){
        fb.db.collection("schools").get().then(querySnapshot=> {
          this.schools=[];
            querySnapshot.forEach(schoolData=> {
              let object=schoolData.data();
              object.id=schoolData.id;
              object.ref=schoolData.ref;

              if(this.schoolId && this.schoolId==object.id){
                this.school=object;
              }
              this.schools.push(object);

            });
        });

        fb.db.collection("semester").get().then(querySnapshot=> {
          this.semesters=[];
            querySnapshot.forEach(schoolData=> {
              let object=schoolData.data();
              object.id=schoolData.id;
              object.ref=schoolData.ref;
              this.semesters.push(object);

            });
        });
      },
      _getDepartments(school){
        if(school && school.ref){
          school.ref.collection("departments").get().then(docs=>{
            this.departments=[];
            docs.docs.forEach(doc=>{
              let object=doc.data();
              object.id=doc.id;
              object.ref=doc.ref;
              
              this.departments.push(object);
              if(this.firstSet!=null && this.firstSet!=undefined && this.firstSet!=true && this.departmentId && object.id==this.departmentId){
                this.department=object;
              }
            });
          });
        }
      },
      _getPros(school){
        if(school && school.ref){
          school.ref.collection("programs").get().then(docs=>{
            this.programs=[];
            docs.docs.forEach(doc=>{
              let object=doc.data();
              object.id=doc.id;
              object.ref=doc.ref;
              this.programs.push(object);
            });
          });
        }
      },
      _getProgramYears(school){
        if(school && school.ref){
          school.ref.collection("programyears").get().then(docs=>{
            this.programyears=[];
            docs.docs.forEach(doc=>{
              let object=doc.data();
              object.id=doc.id;
              object.ref=doc.ref;
              this.programyears.push(object);
            });
          });
        }
      },
      searchStudents(){
        var query=fb.db.collection("students");
        if(this.school){
          if(this.school){
            query=query.where("school", "==", this.school.ref);
          }

          if(this.department){
            query=query.where("department", "==", this.department.ref);
          }
          if(this.program){
            query=query.where("program", "==", this.program.ref);
          }
          if(this.programYear){
            query=query.where("programYear", "==", this.programYear.ref);
          }
          if(this.selectedSemester){
            query=query.where("entry.semester", "==", this.selectedSemester.ref);
          }
        }

        if(query){
          this.searchresults=[];
          query.get().then(docs=>{
            docs.docs.forEach(value=>{
              let object=value.data();
              object.id=value.id;
              object.ref=value.ref;
              this.searchresults.push(object);
            });
          });
        }
      },
      addSearchStudent(student){
        if(student){
          this.addStudentToLesson(fb.db.collection("lessons").doc(this.lessonId), student, null );
        }
      },
      checkStudentIn(student){
        var result=false;
        if(student && this.students && this.students.length>0){
          this.students.forEach(value=>{
            if(value && value.student && value.student.id==student.id){
              result=true;
              return;
            }
          });
        }
        return result;
      }

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        lessonId: { 
            required: true,
        },
        schoolId:{
          required:false
        },
        departmentId:{
          required:false
        }
    },
    created() {
        var _this=this;
        this._getSchools();
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).fromNow()
        }
        return '-'
      },
    
    }
  
};
</script>

